
<div class="component-frame">
  <p>Successfully Logged out</p>
  <button id="message-table-refresh-list-button" type="button" pButton
          class="message-table-header-button login-button" (click)="handleLogin()">Login</button>

</div>
